import { render, staticRenderFns } from "./ColorSelection.vue?vue&type=template&id=2d09113a&scoped=true&"
import script from "./ColorSelection.vue?vue&type=script&lang=js&"
export * from "./ColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09113a",
  null
  
)

export default component.exports